// src/contexts/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import TokenService from "../services/token.service";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [accessToken, setAccessToken] = useState(
    TokenService.getLocalAccessToken()
  );

  // Fired by the axios interceptor (setupInterceptors.js) when a token refresh
  // is rejected — the session was replaced by a login on another device, or
  // the refresh token expired. The interceptor lives outside React and can
  // only clear localStorage; this listener updates React state and moves the
  // user to /login instead of leaving them on a page whose every request fails.
  useEffect(() => {
    const onSessionExpired = () => {
      setAccessToken(null);
      toast.error("Сессия аяқталды. Қайта кіріңіз.");
      navigate("/login", { replace: true });
    };
    window.addEventListener("auth:session-expired", onSessionExpired);
    return () =>
      window.removeEventListener("auth:session-expired", onSessionExpired);
  }, [navigate]);

  const login = ({ access, refresh }) => {
    TokenService.updateLocalAccessToken(access);
    TokenService.updateLocalRefreshToken(refresh);
    setAccessToken(access);
  };

  const logout = () => {
    TokenService.removeTokens();
    setAccessToken(null);
  };

  const isLoggedIn = !!accessToken;

  return (
    <AuthContext.Provider value={{ isLoggedIn, accessToken, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook for usage
export const useAuthContext = () => useContext(AuthContext);
